import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

interface Props {
    className?: string;
}

export const RameInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            ラメ加工の選び方
        </Title>
        <Image
            src={`${ASSETS_PATH}/img/order-help/rame/rame-img-1@2x.png`}
            className="image"
            alt="ラメ"
        />
        <Paragraph>
            下地の糸色によって見え方や発色が異なります。
            明るめのはっきりとした色のものの上にのせるととてもきれいに仕上がります。
            「プチデコレーション」との組み合わせもお薦めです。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpRame: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <RameInner />
            </div>
        </div>
    </Panel>
);
